import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IRichLogData } from "@ryde/shared";

import {
  RichLogsPagination,
  RichViewLogItem,
  useRichLogsContent,
} from "../../rich-logs-components";
import { EtlLogsFilters } from "./etl-logs.filters";

interface IEtlLogsContent {
  logData: IRichLogData | undefined;
  hasExternalLogs?: boolean;
}

export const EtlLogsContent: FC<IEtlLogsContent> = ({
  logData,
  hasExternalLogs,
}) => {
  const { t } = useTranslation();
  const {
    searchText,
    currentPage,
    totalPages,
    startIndex,
    paginatedLogs,
    handleLogItemClick,
  } = useRichLogsContent({ logData });

  return (
    <>
      {logData && (
        <EtlLogsFilters logData={logData} hasExternalLogs={hasExternalLogs} />
      )}

      <RichLogsPagination totalPages={totalPages} currentPage={currentPage} />

      {paginatedLogs.length ? (
        paginatedLogs.map((record, index) => (
          <RichViewLogItem
            key={`${record.timestamp}-${startIndex + index}`}
            record={record}
            onItemClick={handleLogItemClick}
            searchText={searchText}
          />
        ))
      ) : (
        <p className="log__no-logs-found">
          {t("rideProduction.formLabel.noLogsFound")}
        </p>
      )}

      <RichLogsPagination totalPages={totalPages} currentPage={currentPage} />
    </>
  );
};
